import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  display: defineAsyncComponent(() => import("/vercel/path0/layouts/display.vue").then(m => m.default || m)),
  leaderboard: defineAsyncComponent(() => import("/vercel/path0/layouts/leaderboard.vue").then(m => m.default || m))
}